import { Info } from "lucide-react";
import { type ReactElement } from "react";
import { chartConfig } from "..";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils/common";

const StatusKeyItems = ({ className }: { className?: string }): ReactElement => {
  return (
    <ul className={className}>
      {Object.entries(chartConfig).map(([status, config]) => (
        <li key={status} className="flex items-center gap-1.5">
          <span className="h-2 w-2 shrink-0 rounded-[2px]" style={{ backgroundColor: config.color }} />
          <span className="text-sm">{config.label}</span>
        </li>
      ))}
    </ul>
  );
};

export const StatusLegend = ({ className }: { className?: string }): ReactElement => {
  return (
    <StatusKeyItems className={cn("flex items-center justify-center flex-wrap gap-x-4 gap-y-2 pt-3 px-2", className)} />
  );
};

export const StatusKeyPopover = ({ className }: { className?: string }): ReactElement => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label="Show status key"
          className={cn("h-8 w-8 text-muted-foreground", className)}
        >
          <Info className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="space-y-3">
        <p className="text-sm font-medium">Status key</p>
        <StatusKeyItems className="grid grid-cols-2 gap-x-4 gap-y-2" />
        <p className="text-xs text-muted-foreground">Tap a bar to filter bookings by that period</p>
      </PopoverContent>
    </Popover>
  );
};
